import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';

import { Country } from '../../models/lists.model';
import { Organisation } from '../../models/organisation.model';
import { Role } from '../../models/role.model';
import { User } from '../../models/user.model';
import { CapitalizePipe } from '../../pipes/capitalize.pipe';
import { KeycloakService } from '../../services/keycloak.service';
import { ListsService } from '../../services/lists.service';
import { OrganisationService } from '../../services/organisation.service';
import { RoleService } from '../../services/role.service';
import { UserService } from '../../services/user.service';
import { EqualValidator } from '../../utils/equal-validator.directive';
import { showErrorMessage } from '../../utils/utils';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'me-edit',
  templateUrl: 'me-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, FormsModule, EqualValidator, CapitalizePipe, TranslatePipe, TranslateWithPunctuationPipe, CommonModule],
  providers: [UserService, OrganisationService],
})
export class MeEditComponent implements OnInit, OnDestroy {
  @Input() user: User;
  @Output() close = new EventEmitter();
  error: any;
  sub: any;

  edited = false;
  countries: Country[];
  allRoles: Role[];
  organisations: Organisation[];
  userId: number;

  confirmPassword: string;

  indicatif: string[] = ['+33', '+32'];
  prefixPhone: string;
  phone: string;
  prefixMobile: string;
  mobile: string;

  constructor(
    private userService: UserService,
    private roleService: RoleService,
    private listService: ListsService,
    private organisationService: OrganisationService,
    private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  goBack(savedUser: User = null) {
    this.close.emit(savedUser);
    window.history.back();
    return false;
  }

  handleCountries(countries: Country[]) {
    this.countries = countries;

    this.indicatif = [];
    for (const country of countries) {
      this.indicatif.push(country.telCountryCode);
    }
    this.indicatif.sort();
  }

  getOrganisations() {
    this.organisationService.getOrganisations().subscribe((organisations) => (this.organisations = organisations));
  }

  save() {
    if (this.phone) {
      this.user.phone = this.prefixPhone + this.phone;
    }
    this.user.mobile = this.prefixMobile + this.mobile;
    this.userService.save(this.user).subscribe(
      (user) => {
        this.user = user;
        KeycloakService.auth.authz.tokenParsed.name = user.firstName + ' ' + user.lastName;
        this.goBack(user);
      },
      (error) => this.handleSaveError(error),
    );
  }

  ngOnInit() {
    this.listService.getCountries().subscribe((countries) => {
      this.handleCountries(countries);

      this.sub = this.route.params.subscribe((params) => {
        if (this.route.snapshot.url[1].path === 'edit') {
          this.edited = true;
          this.userService.getMe().subscribe(
            (user) => {
              this.user = user;
              if (user.phone) {
                this.phone = user.phone.substring(3, 13);
                this.prefixPhone = user.phone.substring(0, 3);
                if (!(this.indicatif.indexOf(this.prefixPhone) > -1)) {
                  this.phone = user.phone;
                  this.prefixPhone = null;
                }
              } else {
                this.prefixPhone = null;
              }
              if (user.mobile) {
                this.mobile = user.mobile.substring(3, 13);
                this.prefixMobile = user.mobile.substring(0, 3);
                if (!(this.indicatif.indexOf(this.prefixMobile) > -1)) {
                  this.mobile = user.mobile;
                  this.prefixMobile = null;
                }
              } else {
                this.prefixMobile = null;
              }
              if (!user.country) {
                user.country = new Country();
                user.country.id = null;
              }
              if (!this.user.country) {
                this.user.country = new Country();
                this.user.country.id = null;
              }
            },
            (error) => this.handleGetError(error),
          );
        }
      });
    });
  }

  handleSaveError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à modifier cet utilisateur");
    } else {
      // FIXME détailler les erreurs du formulaire
      // FIXME définir un format pour les erreurs de validation
      console.error(error);
      showErrorMessage(this.modal, 'Il y a des erreurs dans le formulaire');
    }
  }

  handleGetError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à consulter cet utilisateur").then((r) => {
        this.router.navigate(['/']);
      });
    } else {
      console.error(error);
      showErrorMessage(this.modal, 'Une erreur est survenue').then((r) => {
        this.router.navigate(['/']);
      });
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
